import React, { useEffect, useState, useRef } from 'react';
import Loader from '../components/loader';
import AuthService from "../services/auth.service";
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import Board from '../components/board';
import { Modal } from "react-bootstrap";
import Fairnesss from "../components/fairnesss"
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../app/store';
import { fetchWallet } from '../app/slice/walletSlice';
import { showToast } from '../app/slice/toastsSlice';

function Mines() {
  const walletAmount = useSelector((state: RootState) => state.wallet.wallet);
  const [isPageloading, setIsPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showfairnesss, setFairnesss] = useState(false);
  const handleClosefairnesss = () => setFairnesss(false);
  const handleShowfairnesss = () => setFairnesss(true);
  const [gridLength, setGridLength] = useState<number>(5);
  const [bombLength, setBombLength] = useState<number>(1);
  const [betType, setBetType] = useState<any>('manual');
  const [betAmount, setBetAmount] = useState<number | any>(0);
  const [isCashout, setIsCashout] = useState(false);
  const [wallet, setWallet] = useState<any | Number>(walletAmount);
  const [isRandomSelect, setIsRandomSelect] = useState(false);
  const [isGameActive, setIsGameActive] = useState(false);
  const [gameData, setGameData] = useState<any>({});
  const [autoRounds, setAutoRounds] = useState<number[]>([]);
  const [noOfBet, setNoOfBet] = useState<number | any>(1);
  const [remainingBet, setRemainingBet] = useState<number | any>(1);
  const [onWin, setOnWin] = useState<number | any>(0);
  const [onLoss, setOnLoss] = useState<number | any>(0);
  const [isOnWin, setIsOnWin] = useState<boolean>(false);
  const [isOnLoss, setIsOnLoss] = useState<boolean>(false);
  const [stopOnLoss, setStopOnLoss] = useState<number | any>(0);
  const [stopOnProfit, setStopOnProfit] = useState<number | any>(0);
  const [currentLoss, setCurrentLoss] = useState<number>(0);
  const [currentProfit, setCurrentProfit] = useState<number>(0);
  const [attempts, setAttempts] = useState<number>(0);
  const [isAutoCall, setIsAutoCall] = useState<boolean>(false);
  // const [isMaxBet, setIsMaxBet] = useState<boolean>(false);
  // const [isMute, setIsMute] = useState<boolean>(false);
  const [message, setMessage] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const isStopped = useRef<boolean>(false);

  const [isMute, setIsMute] = useState<boolean>(() => {
    const mute = localStorage.getItem('setting_mute');
    return mute ? mute === 'true' : false;
  });

  const [isMaxBet, setIsMaxBet] = useState<boolean>(() => {
    const maxBet = localStorage.getItem('setting_maxBet');
    return maxBet ? maxBet === 'true' : false;
  });

  const [isAnimation, setIsAnimation] = useState<boolean>(() => {
    const animation = localStorage.getItem('setting_animation');
    return animation ? animation === 'true' : true;
  });

  const [isInstant, setIsInstant] = useState<boolean>(() => {
    const instant = localStorage.getItem('setting_instant');
    return instant ? instant === 'true' : false;
  });



  useEffect(() => {
    localStorage.setItem('setting_mute', String(isMute));
  }, [isMute]);

  useEffect(() => {
    localStorage.setItem('setting_maxBet', String(isMaxBet));
  }, [isMaxBet]);

  useEffect(() => {
    localStorage.setItem('setting_animation', String(isAnimation));
  }, [isAnimation]);

  useEffect(() => {
    localStorage.setItem('setting_instant', String(isInstant));
  }, [isInstant]);

  useEffect(() => {
    setWallet(walletAmount);
  }, [walletAmount]);

  useEffect(() => {
    AuthService.getActiveMinesGame()
      .then(
        (response) => {
          // console.log(response.data);
          if (response.status === 200) {
            if (Object.keys(response?.data).length > 0) {
              setGameData(response?.data);
              setIsGameActive(response?.data?.minesNext?.active === 1 ? true : false);
              setBetAmount(response?.data?.minesNext?.amount);
              setBetType(response?.data?.state?.type);
              setBombLength(response?.data?.state?.minesCount);
              setGridLength(response?.data?.state?.grid);
            }

          } else {
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        }
      }).finally(() => {
        setIsPageLoading(false);
      });
  }, []);

  function handleClickBetType(type: any) {
    setBetType(type);
    // if(type==='manual'){
    setAutoRounds([]);
    // setBetAmount(0);
    setGameData({});
    setIsCashout(false);
    // }
  };

  const handleSelectGrid = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = Number(event.target.value);
    setGridLength(value);
    setGameData({});
    setBombLength(1);
    setIsCashout(false);
  };

  const handleSelectBomb = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = Number(event.target.value);
    setBombLength(value);
    setGameData({});
    setIsCashout(false);
  };

  const handleRightClick = (e: React.MouseEvent) => {
    e.preventDefault();
    return;
    // Implement flagging logic here if needed
  };

  const onChangeAmount = (e: any) => {
    //let amount = Number(e.target.value); 
    if (!isNaN(e.target.value)) {
      setBetAmount(e.target.value);
    }
  };

  const handleAmountAdd = (event: any, amt: number) => {
    event.preventDefault();
    if (amt > wallet?.user_combined_wallet) {
      setBetAmount(wallet?.user_combined_wallet);
      return;
    }
    setBetAmount(Number(amt).toFixed(2));
  };

  function handleClickRandom() {
    setIsRandomSelect(true);
  }

  function handlePlaceBet() {
    setLoading(true);
    // if (Number(betAmount) < 1) {
    //   let toast = {
    //     type: 'error',
    //     title: 'Error',
    //     message: 'Bet amount should be greater than 1'
    //   }
    //   dispatch(showToast(toast));
    //   setLoading(false);
    //   return;
    // }

    if (Number(betAmount) > Number(wallet?.user_combined_wallet)) {
      let toast = {
        type: 'error',
        title: 'Error',
        message: 'Insufficient Balance'
      }
      dispatch(showToast(toast));
      setLoading(false);
      return;
    }

    let formData = {
      rows: gridLength,
      mines: bombLength,
      betAmount: betAmount,
      type: betType
    }
    AuthService.minesGame(formData)
      .then(
        (response) => {
          //console.log(response.data);
          if (response.status === 200) {
            dispatch(fetchWallet());
            setGameData(response?.data);
            setIsGameActive(response?.data?.minesNext?.active === 1 ? true : false);
            setBetAmount(response?.data?.minesNext?.amount);
            setBetType(response?.data?.state?.type);
            setIsCashout(false);
          } else {
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        } else {
          let toast = {
            type: 'error',
            title: 'Error',
            message: message
          }
          dispatch(showToast(toast));
        }
      }).finally(() => {
        setLoading(false);
      });

  }

  function handleCashout() {
    AuthService.chashOutMines()
      .then(
        (response) => {
          // console.log(response.data);
          if (response.status === 200) {
            setGameData(response?.data);
            setIsGameActive(false);
            setIsCashout(true);
            setBetAmount(0);
            dispatch(fetchWallet());
            if (!isMute) {
              let sound = new Audio(AuthService?.baseUrlImage + response?.data?.state?.sound);
              sound.play();
            }

          } else {
            setMessage(response?.message);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        }
      }).finally(() => {
        setLoading(false);
      });
  }


  const handleCellClick = (cellNo: any) => {
    if (!isGameActive) return;
    //if (loading) return;
    setLoading(true);
    if(isAnimation){
      $('.grid' + cellNo?.field).addClass('cellAnimationClick');
    }    

    AuthService.checkCellData(cellNo)
      .then(
        (response) => {
          //console.log(response);
          if (response.status === 200) {
            setIsRandomSelect(false);
            setGameData(response?.data);
            setIsGameActive(response?.data?.minesNext?.active === 1 ? true : false);
            setBetAmount(response?.data?.minesNext?.active === 1 ? response?.data?.minesNext?.amount : 0);
            setBetType(response?.data?.state?.type);
            if (!isMute) {
              let sound = new Audio(AuthService?.baseUrlImage + response?.data?.state?.sound);
              sound.play();
            }

            if (response?.data?.minesNext?.win) {
              setIsCashout(true);
            }
            if (response?.data?.minesNext?.active === 0) {
              setBetAmount(0);
              setIsCashout(true);
            }

          } else {
            if (response.status !== 204) {
              setMessage(response?.message);
              let toast = {
                type: 'error',
                title: 'Error',
                message: response?.message
              }
              dispatch(showToast(toast));
            }
            
            $('.grid' + cellNo?.field).removeClass('cellAnimationClick');
            setLoading(false);
          }
        }
      ).catch((error) => {
        const message = error?.response?.data?.error_description;
        setMessage(message);
        if (error?.response?.data?.status === 401) {
          localStorage.removeItem("w_token");
          navigate('/login');
        } else {
          let toast = {
            type: 'error',
            title: 'Error',
            message: message
          }
          dispatch(showToast(toast));
          $('.grid' + cellNo?.field).removeClass('cellAnimationClick');
          setLoading(false);
        }
      }).finally(() => {
        setLoading(false);
        $('.grid' + cellNo?.field).removeClass('cellAnimationClick');
      });

  }


  const setAutoRoundsValue = (cellNo: any) => {
    if (cellNo?.length > 0) {
      setAutoRounds(cellNo);
    } else {
      setAutoRounds([]);
    }
  }

  const handleStopLossChange = (e: any) => {
    const inputValue = e.target.value;
    if (inputValue === "" || !isNaN(Number(inputValue))) {
      setStopOnLoss(inputValue);
    }
  };

  const handleStopProfitChange = (e: any) => {
    const inputValue = e.target.value;
    if (inputValue === "" || !isNaN(Number(inputValue))) {
      setStopOnProfit(inputValue);
    }
  };

  const handleOnLossChange = (e: any) => {
    const inputValue = e.target.value;
    if (inputValue === "" || !isNaN(Number(inputValue))) {
      setOnLoss(inputValue);
    }
  };

  const handleOnWinChange = (e: any) => {
    const inputValue = e.target.value;
    if (inputValue === "" || !isNaN(Number(inputValue))) {
      setOnWin(inputValue);
    }
  };

  const handleNoBetChange = (e: any) => {
    const inputValue = e.target.value;
    if (inputValue === "" || !isNaN(Number(inputValue))) {
      setNoOfBet(inputValue);
      setRemainingBet(inputValue);
    }

  };

  useEffect(() => {
    const autoCallApi = async () => {
      try {
        // Only call the next API if not stopped

        if (!isStopped.current && isAutoCall) {

          //setLoading(true);
          // setNoOfBet(remainingBet);
          setGameData({});
          setIsCashout(false);

          // if (Number(betAmount) < 1) {
          //   let toast = {
          //     type: 'error',
          //     title: 'Error',
          //     message: 'Bet amount should be greater than 1'
          //   }
          //   dispatch(showToast(toast));
          //   setLoading(false);
          //   return;
          // }

          if (Number(betAmount) > Number(wallet?.user_combined_wallet)) {
            let toast = {
              type: 'error',
              title: 'Error',
              message: 'Insufficient Balance'
            }
            dispatch(showToast(toast));
            setLoading(false);
            setIsAutoCall(false);
            return;
          }

          let formData = {
            rows: gridLength,
            mines: bombLength,
            betAmount: betAmount,
            type: betType,
            field: autoRounds.toString(), //autoRounds,
            noOfBet: noOfBet,
            onWin: onWin,
            onLoss: onLoss,
            stopOnLoss: stopOnLoss,
            stopOnProfit: stopOnProfit
          }
          // console.log(formData); return

          await AuthService.minesAutoPlay(formData)
            .then(
              (response) => {
                // console.log(response.data);
                if (response.status === 200) {
                  dispatch(fetchWallet());
                  if (!isMute) {
                    let sound = new Audio(AuthService?.baseUrlImage + response?.data?.state?.sound);
                    sound.play();
                  }
                  setGameData(response?.data);
                  setIsGameActive(response?.data?.minesNext?.active === 1 ? true : false);
                  setBetType(response?.data?.state?.type);
                  setAttempts((prev: number) => prev + 1);
                  
                  if (noOfBet > 0) {
                    setRemainingBet((prev: any) => prev - 1);
                  }

                  if (response?.data?.minesNext?.win) {
                    setIsCashout(true);
                    let newAmt = (Number(betAmount) + Number(betAmount) * Number(onWin) / 100).toFixed(2);

                    if (attempts + 1 < Number(noOfBet)) {
                      setBetAmount(newAmt);
                    }

                    let profit = (Number(response?.data?.minesNext?.amountMultiplier) - Number(response?.data?.minesNext?.amount)).toFixed(2);
                    setCurrentProfit((prev: number) => prev + Number(profit));

                  } else {
                    let newAmt = (Number(betAmount) + Number(betAmount) * Number(onLoss) / 100).toFixed(2);
                    if (attempts + 1 < Number(noOfBet)) {
                      setBetAmount(newAmt);
                    }

                    let loss = Number(response?.data?.minesNext?.amount).toFixed(2);
                    setCurrentLoss((prev: number) => prev + Number(loss));
                  }

                } else {
                  setMessage(response?.message);
                  let toast = {
                    type: 'error',
                    title: 'Error',
                    message: response?.message
                  }
                  dispatch(showToast(toast));
                  setIsAutoCall(false);
                  isStopped.current = true;
                }
              }
            ).catch((error) => {
              const message = error?.response?.data?.error_description;
              setMessage(message);
              setIsAutoCall(false);
              isStopped.current = true;
              if (error?.response?.data?.status === 401) {
                localStorage.removeItem("w_token");
                navigate('/login');
              }
              let toast = {
                type: 'error',
                title: 'Error',
                message: message
              }
              dispatch(showToast(toast));
            }).finally(() => {
              setLoading(false);
            });

        }
      } catch (err) {
        setIsAutoCall(false);
        isStopped.current = true;
        alert('An error occurred during the API call');
      }
    };

    let intervalId: NodeJS.Timeout | undefined;
    
    if (isAutoCall) {

      intervalId = setInterval(() => {
        if ((Number(stopOnProfit) > 0 && currentProfit < Number(stopOnProfit)) || Number(stopOnProfit) === 0 || stopOnProfit === '') {
          if ((Number(stopOnLoss) > 0 && Number(currentLoss) < Number(stopOnLoss)) || Number(stopOnLoss) === 0 || stopOnLoss === '') {
            if ((Number(noOfBet) > 0 && Number(attempts) < Number(noOfBet)) || Number(noOfBet) === 0 || noOfBet === '') {

              autoCallApi();

            } else {
              setIsAutoCall(false);
              setAttempts(0);
              setCurrentLoss(0);
              setCurrentProfit(0);
            }
          } else {
            setIsAutoCall(false);
            setAttempts(0);
            setCurrentLoss(0);
            setCurrentProfit(0);
          }
        } else {
          setIsAutoCall(false);
          setAttempts(0);
          setCurrentLoss(0);
          setCurrentProfit(0);
        }
      }, isInstant ? 900 : 1500);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };

  }, [isAutoCall, gameData]);

  function stopAutoBet() {
    setIsAutoCall(false);
    setIsCashout(false);

    setAttempts(0);
    setCurrentLoss(0);
    setCurrentProfit(0);
    isStopped.current = true;
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setGameData({});
      setIsCashout(false);
    }, 800);
  }

  const handleStart = () => {
    setIsAutoCall(true);
    setLoading(true);
    isStopped.current = false; // Reset stopped flag
    setGameData({});
    setAttempts(0);
    setNoOfBet(remainingBet);
    setIsCashout(false);
  };

  return (
    <>
      <style>
        {`
        .fairnesss.modal.fade .modal-dialog {
            transition: transform .3s ease-out;
          transform: translate(0%,100%) !important;
          }
          .fairnesss.modal.show .modal-dialog{
            transform: none !important;
          }
          @media screen and (min-width: 1024px) {
            .fairnesss.modal.fade .modal-dialog {
              transition: transform .3s ease-out;
              transform: translate( 100%,0%) !important;
            }
            .fairnesss.modal.show .modal-dialog{
              transform: none !important;
            }
          }
        `}
      </style>
      <div>
        {isPageloading && <Loader />}
        <div className="container webMine" onContextMenu={(e: React.MouseEvent) => handleRightClick(e)}>
          <div className="row gameBagk">
            <div className="col-12 position-relative p-0">
              <Board size={gridLength} numBombs={bombLength} isRandomSelect={isRandomSelect} setBetData={handleCellClick} gameData={gameData} isCashout={isCashout} setAutoRounds={setAutoRoundsValue} betType={betType} isAutoCall={isAutoCall} />
            </div>

          </div>
          <div className='row bg-dark-Bet'>
            <div className="tab-content" id="pills-tabContent">

              <div className="col-12 betSelection mb-my webMineTab">
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className={`nav-link${betType === 'manual' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('manual') : undefined}>Manual Bet</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className={`nav-link${betType === 'auto' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('auto') : undefined}>Auto Bet</button>
                  </li>
                </ul>
              </div>

              <div className="tab-pane fade show active">
                <div className="row">
                  {betType === 'auto' &&
                    <div className="col-12 mb-my mt-3">
                      {isAutoCall ?
                        <button className='betBtn' onClick={!loading ? () => stopAutoBet() : undefined} disabled={loading}>
                          {loading ?
                            <>
                              Please wait...
                            </>
                            :
                            <>
                              Stop Auto Bet
                            </>
                          }
                        </button>

                        :
                        <button className='betBtn' onClick={!loading ? () => handleStart() : undefined} disabled={betAmount === '' || autoRounds.length === 0 || loading ? true : false}>
                          {loading ?
                            <>
                              Please wait...
                            </>
                            :
                            <>
                              Start Auto Bet
                            </>
                          }
                        </button>

                      }
                    </div>
                  }
                  <div className="col-12 mb-my mt-2">
                    <div className='d-flex justify-content-between'>
                      <label htmlFor='amount'>Bet Amount</label>
                      <label htmlFor='amount'>00000000000 USDT</label>
                    </div>
                    <div className='amountInpunt'>
                      <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                        <p>₹</p>
                        <input type="text" id="amount" placeholder="enter amount" value={betAmount} onChange={(e) => onChangeAmount(e)} maxLength={10} autoComplete="off" readOnly={loading || isGameActive || isAutoCall} />
                      </div>
                      <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', width: '100%' }}>
                        <button onClick={!isGameActive ? event => handleAmountAdd(event, betAmount / 2) : undefined} disabled={loading || isGameActive || isAutoCall}>1/2</button>
                        <button onClick={!isGameActive ? event => handleAmountAdd(event, betAmount * 2) : undefined} disabled={loading || isGameActive || isAutoCall}>2x</button>
                        {isMaxBet &&
                          <button onClick={!isGameActive ? event => handleAmountAdd(event, wallet?.user_combined_wallet) : undefined} disabled={loading || isGameActive || isAutoCall}>All In</button>
                        }
                      </div>
                    </div>
                  </div>
                  <div className="col-6 mb-my">
                    <label htmlFor='grid'>Grid</label>
                    <div className="custom-select">
                      <select id="grid" value={gridLength} onChange={!isGameActive ? handleSelectGrid : undefined} disabled={loading || isGameActive || isAutoCall}>
                        <option value="4">4 X 4</option>
                        <option value="5">5 X 5</option>
                        <option value="6">6 X 6</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-6 mb-my">
                    <label htmlFor='mines'>Mines</label>
                    <div className="custom-select">
                      <select id="mines" value={bombLength} onChange={!isGameActive ? handleSelectBomb : undefined} disabled={loading || isGameActive || isAutoCall}>
                        {gridLength && [...Array(Number(gridLength) * Number(gridLength) - 1)].map((_, index: any) => (
                          <option value={index + 1} key={index}>{index + 1}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {betType === 'auto' &&
                    <>
                      <div className="col-12 mb-my">
                        <label htmlFor='no_of_bet'>No.of Bets</label>
                        <div className='amountInpunt'>
                          <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                            <input type="number" id="no_of_bet" value={noOfBet > 0 ? remainingBet : noOfBet} onChange={handleNoBetChange} autoComplete='off' min={0} readOnly={isAutoCall} />
                          </div>
                          {(Number(noOfBet) === 0 || noOfBet === '') &&
                            <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', }}>
                              <button style={{ background: 'none' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M3 12C3 10.067 4.567 8.5 6.5 8.5C7.7035 8.5 8.51959 8.9338 9.19914 9.61336C9.9255 10.3397 10.4851 11.3322 11.1258 12.4856L11.1595 12.5462C11.7605 13.6283 12.4431 14.8573 13.3866 15.8009C14.3946 16.8088 15.7035 17.5 17.5 17.5C20.5376 17.5 23 15.0376 23 12C23 8.96243 20.5376 6.5 17.5 6.5C15.8394 6.5 14.3508 7.2359 13.3423 8.39937C13.7887 9.05406 14.1574 9.70577 14.464 10.2574C15.0681 9.20718 16.2014 8.5 17.5 8.5C19.433 8.5 21 10.067 21 12C21 13.933 19.433 15.5 17.5 15.5C16.2965 15.5 15.4804 15.0662 14.8009 14.3866C14.0745 13.6603 13.5149 12.6678 12.8742 11.5144L12.8405 11.4538C12.2395 10.3717 11.5569 9.14265 10.6134 8.19914C9.60541 7.1912 8.2965 6.5 6.5 6.5C3.46243 6.5 1 8.96243 1 12C1 15.0376 3.46243 17.5 6.5 17.5C8.16056 17.5 9.64923 16.7641 10.6577 15.6006C10.2113 14.9459 9.84262 14.2942 9.53605 13.7426C8.93194 14.7928 7.79856 15.5 6.5 15.5C4.567 15.5 3 13.933 3 12Z" fill="white" />
                                </svg>
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                      <div className="col-12 mb-my">
                        <label htmlFor='on_win'>On Win</label>
                        <div className='amountInpunt p-0'>
                          <div className='d-flex align-items-center justify-content-start' style={{ height: '100%', width: '100%' }}>
                            <button onClick={() => { setOnWin(0); setIsOnWin(false) }} className={`${!isOnWin ? 'active-on' : ''}`} disabled={loading || isAutoCall}>Reset</button>
                            <button style={{ borderRight: '2px solid rgb(35 36 40)' }} onClick={() => setIsOnWin(true)} className={`${isOnWin ? 'active-on' : ''}`} disabled={loading || isAutoCall}>Increased Bet</button>
                          </div>
                          <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                            <input type="number" id="on_win" value={onWin} onChange={handleOnWinChange} autoComplete='off' readOnly={!isOnWin || isAutoCall} />
                            <button style={{ background: 'none', color: '#fff' }}>%</button>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-my">
                        <label htmlFor='on_loss'>On Loss</label>
                        <div className='amountInpunt p-0'>
                          <div className='d-flex align-items-center justify-content-start' style={{ height: '100%', width: '100%' }}>
                            <button onClick={() => { setOnLoss(0); setIsOnLoss(false) }} className={`${!isOnLoss ? 'active-on' : ''}`} disabled={loading || isAutoCall}>Reset</button>
                            <button style={{ borderRight: '2px solid rgb(35 36 40)' }} onClick={() => setIsOnLoss(true)} className={`${isOnLoss ? 'active-on' : ''}`} disabled={loading || isAutoCall}>Increased Bet</button>
                          </div>
                          <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                            <input type="number" id="on_loss" value={onLoss} onChange={handleOnLossChange} autoComplete='off' readOnly={!isOnLoss || isAutoCall} maxLength={4} />
                            <button style={{ background: 'none', color: '#fff' }}>%</button>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-my">
                        <div className='d-flex justify-content-between'>
                          <label htmlFor='stop_on_profit'>Stop on Profit</label>
                          <label>00000000000  USDT</label>
                        </div>
                        <div className='amountInpunt'>
                          <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                            <input type="text" id="stop_on_profit" value={stopOnProfit} onChange={handleStopProfitChange} autoComplete='off' readOnly={isAutoCall} />
                          </div>
                          <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', }}>
                            <button style={{ background: 'none', color: '#fff' }}>
                              INR
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 mb-my">
                        <div className='d-flex justify-content-between'>
                          <label htmlFor='stop_on_loss'>Stop on Loss</label>
                          <label>000000000000 USDT</label>
                        </div>
                        <div className='amountInpunt'>
                          <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                            <input type="text" id="stop_on_loss" value={stopOnLoss} onChange={handleStopLossChange} autoComplete='off' readOnly={isAutoCall} />
                          </div>
                          <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', }}>
                            <button style={{ background: 'none', color: '#fff' }}>
                              INR
                            </button>
                          </div>
                        </div>
                      </div>
                    </>

                  }
                  {betType === 'manual' &&
                    <>
                      {isGameActive &&

                        <>
                          <div className="col-12 mb-my mt-2">
                            <button className='Cashout' onClick={handleCashout} disabled={gameData?.state?.rounds?.length <= 0 || loading ? true : false}>
                              Cashout <b>₹{gameData?.minesNext?.amountMultiplier}</b>
                            </button>
                          </div>

                          <div className="col-12 mb-my">
                            <button className='pickRandom' onClick={handleClickRandom} disabled={loading ? true : false}>
                              Pick Random Tile
                            </button>
                          </div>
                        </>
                      }
                      {(isGameActive || gameData?.minesNext?.win) &&
                        <div className="col-12 mb-my">
                          <div className='d-flex justify-content-between'>
                            <label>Total Profit  ({gameData?.minesNext?.payoutMultiplier}x)</label>
                            <label>$0.00</label>
                          </div>
                          <div className='amountInpunt'>
                            <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                              <p>{gameData?.minesNext?.amountMultiplier}</p>

                            </div>
                            <div className='d-flex align-items-center justify-content-end' style={{ height: '100%' }}>
                              <button style={{ background: 'none', color: '#fff' }}>
                                INR
                              </button>
                            </div>
                          </div>
                        </div>

                      }
                      {!isGameActive &&
                        <div className="col-12 mb-my mt-2">
                          <button className='betBtn' onClick={!loading ? handlePlaceBet : undefined} disabled={loading || betAmount === '' ? true : false}>
                            {loading ?
                              <>
                                Please wait...
                              </>
                              :
                              <>
                                Bet
                              </>
                            }
                          </button>
                        </div>
                      }
                    </>
                  }

                </div>
              </div>
              <div className="col-12 betSelection mb-my">
                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className={`nav-link${betType === 'manual' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('manual') : undefined}>Manual Bet</button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button className={`nav-link${betType === 'auto' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('auto') : undefined}>Auto Bet</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row mt-3 liveBack">
            <div className="col-6 setingsBtn mb-my">
              <div className="dropdown">
                <button className="btn btn-secondary dropdown-toggle" data-bs-auto-close="outside" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 25 25" fill="none">
                    <path d="M10.3991 2.39402C11.779 2.10517 13.2205 2.09605 14.632 2.39118C14.8152 3.59099 15.5218 4.69972 16.6547 5.35379C17.7875 6.00784 19.1011 6.06548 20.2317 5.62413C21.1931 6.69908 21.906 7.95198 22.3457 9.29143C21.3995 10.0499 20.7936 11.2155 20.7936 12.5225C20.7936 13.8304 21.4002 14.9966 22.3474 15.755C22.1287 16.4177 21.8394 17.0681 21.4768 17.6962C21.1141 18.3244 20.6955 18.9001 20.2309 19.4208C19.1005 18.9797 17.7873 19.0375 16.6547 19.6913C15.5227 20.3449 14.8163 21.4524 14.6325 22.6512C13.2526 22.94 11.8112 22.9491 10.3995 22.654C10.2164 21.4542 9.50974 20.3454 8.37688 19.6913C7.24403 19.0373 5.93049 18.9797 4.79988 19.4211C3.83846 18.3461 3.12563 17.0931 2.68585 15.7537C3.63209 14.9952 4.23798 13.8296 4.23798 12.5225C4.23798 11.2148 3.63138 10.0486 2.6842 9.2901C2.90282 8.62744 3.19214 7.97709 3.55479 7.34895C3.91745 6.7208 4.33602 6.14507 4.80059 5.62441C5.93105 6.06545 7.24427 6.0077 8.37688 5.35379C9.50884 4.70024 10.2153 3.59275 10.3991 2.39402ZM12.5158 15.6267C14.2301 15.6267 15.62 14.237 15.62 12.5225C15.62 10.8082 14.2301 9.4184 12.5158 9.4184C10.8014 9.4184 9.4116 10.8082 9.4116 12.5225C9.4116 14.237 10.8014 15.6267 12.5158 15.6267Z" fill="white" />
                  </svg>
                </button>
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li className={isInstant ? 'activeSetings' : ''}>
                    <button className="dropdown-item" onClick={() => setIsInstant(!isInstant)}>
                      <svg className='me-1' width="16" height="16" viewBox="0 0 12 12" fill="" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.38113 4.1156C9.36507 4.08108 9.33949 4.05186 9.30739 4.03138C9.27529 4.01091 9.23801 4.00002 9.19994 4.00001H6.82994L9.16893 0.307008C9.18808 0.276767 9.19876 0.241939 9.19985 0.206162C9.20094 0.170384 9.19241 0.13497 9.17514 0.103617C9.15788 0.0722415 9.13252 0.0460741 9.1017 0.0278475C9.07088 0.00962092 9.03573 3.63971e-06 8.99992 0L5.79993 0C5.76277 4.90728e-06 5.72634 0.0103536 5.69473 0.0298874C5.66312 0.0494213 5.63757 0.077369 5.62094 0.110602L2.62094 6.1106C2.60571 6.14106 2.59852 6.17491 2.60006 6.20894C2.6016 6.24296 2.61181 6.27603 2.62973 6.30499C2.64766 6.33401 2.67271 6.35796 2.70249 6.37459C2.73228 6.39121 2.76582 6.39995 2.79993 6.39998H4.85652L2.61552 11.7224C2.59704 11.7665 2.59495 11.8158 2.60962 11.8613C2.62429 11.9068 2.65476 11.9456 2.69551 11.9706C2.73633 11.9955 2.78471 12.005 2.83191 11.9974C2.87912 11.9897 2.92204 11.9655 2.95293 11.929L9.35294 4.32898C9.37747 4.29979 9.39316 4.2642 9.39815 4.2264C9.40315 4.1886 9.39724 4.15016 9.38113 4.1156Z" fill="" />
                      </svg>
                      Instant Bet
                    </button>
                  </li>
                  <li className={isAnimation ? 'activeSetings' : ''}>
                    <button className="dropdown-item" onClick={() => setIsAnimation(!isAnimation)}>
                      <svg className='me-1' width="16" height="16" viewBox="0 0 16 16" fill="" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2499_6868)">
                          <path d="M14.0592 1.94058C16.1132 3.99466 16.1134 7.3249 14.0592 9.37898C12.0051 11.4332 8.67484 11.4332 6.62076 9.37898C4.56652 7.3249 4.56652 3.99466 6.62076 1.94058C8.67468 -0.113658 12.0051 -0.113658 14.0592 1.94058Z" fill="" />
                          <path d="M3.73185 5.82248C1.95201 7.60248 1.95201 10.4882 3.73185 12.2682C5.51169 14.0482 8.39761 14.0482 10.1776 12.2682L10.2136 12.231C10.3027 12.1378 10.2696 12.0838 10.1432 12.1087C8.45889 12.4399 6.64257 11.9558 5.34289 10.6561C4.04177 9.35512 3.55873 7.5372 3.89297 5.8524C3.91793 5.726 3.86481 5.69352 3.77281 5.7836C3.75941 5.7967 3.74607 5.80987 3.73281 5.82312L3.73185 5.82248Z" fill="" />
                          <path d="M1.4799 9.305C0.0399024 10.745 0.0399024 13.0799 1.4799 14.52C2.9199 15.9602 5.25494 15.96 6.69494 14.52C6.70294 14.512 6.71254 14.502 6.72054 14.4936C6.79526 14.4165 6.76774 14.372 6.66262 14.3925C5.30118 14.6584 3.83414 14.2663 2.7839 13.2162C1.73254 12.1648 1.34134 10.6965 1.60982 9.33476C1.63062 9.22964 1.58646 9.20292 1.5103 9.2786L1.48166 9.30708L1.4799 9.305Z" fill="" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2499_6868">
                            <rect width="16" height="16" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      Animations</button>
                  </li>
                  <li className={isMaxBet ? 'activeSetings' : ''}>
                    <button className="dropdown-item" onClick={() => setIsMaxBet(!isMaxBet)}>
                      <svg className='me-1' width="16" height="16" viewBox="0 0 16 16" fill="" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14 6.33333V8.33333C14 9.9902 11.3137 11.3333 8 11.3333C4.68629 11.3333 2 9.9902 2 8.33333V6.33333C2 7.9902 4.68629 9.33333 8 9.33333C11.3137 9.33333 14 7.9902 14 6.33333ZM2 9.66667C2 11.3235 4.68629 12.6667 8 12.6667C11.3137 12.6667 14 11.3235 14 9.66667V11.6667C14 13.3235 11.3137 14.6667 8 14.6667C4.68629 14.6667 2 13.3235 2 11.6667V9.66667ZM8 8C4.68629 8 2 6.65685 2 5C2 3.34315 4.68629 2 8 2C11.3137 2 14 3.34315 14 5C14 6.65685 11.3137 8 8 8Z" fill="" />
                      </svg>
                      Max Bet</button>
                  </li>
                </ul>
              </div>
              <button onClick={() => setIsMute(!isMute)}>
                {!isMute ?
                  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.56958 16.523H6.45847L11.753 20.8548C11.8423 20.9279 11.9542 20.9678 12.0696 20.9678C12.3457 20.9678 12.5696 20.744 12.5696 20.4678V4.57814C12.5696 4.46272 12.5297 4.35085 12.4566 4.26152C12.2817 4.0478 11.9667 4.0163 11.753 4.19116L6.45847 8.52302H2.56958C2.0173 8.52302 1.56958 8.97073 1.56958 9.52302V15.523C1.56958 16.0753 2.0173 16.523 2.56958 16.523ZM23.5696 12.5229C23.5696 15.8149 22.1235 18.7692 19.8318 20.7851L18.4141 19.3673C20.3454 17.7166 21.5696 15.2627 21.5696 12.5229C21.5696 9.78311 20.3454 7.32924 18.4141 5.67852L19.8318 4.26074C22.1235 6.27663 23.5696 9.2309 23.5696 12.5229ZM18.5696 12.5229C18.5696 10.6112 17.6756 8.90843 16.2829 7.80968L14.8538 9.23879C15.8909 9.9615 16.5696 11.1629 16.5696 12.5229C16.5696 13.8829 15.8909 15.0843 14.8538 15.807L16.2829 17.2361C17.6756 16.1374 18.5696 14.4345 18.5696 12.5229Z" fill="white" />
                  </svg>
                  :
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2499_6841)">
                      <path d="M5.69478 16.3686H1.95622C1.42529 16.3686 0.994873 15.9382 0.994873 15.4073V9.6392C0.994873 9.10826 1.42529 8.67786 1.95622 8.67786H5.69478L10.7846 4.51345C10.9901 4.34535 11.2929 4.37563 11.461 4.58109C11.5313 4.66697 11.5697 4.77451 11.5697 4.88547V20.161C11.5697 20.4265 11.3544 20.6416 11.089 20.6416C10.9781 20.6416 10.8705 20.6033 10.7846 20.533L5.69478 16.3686ZM19.6586 12.5233L23.0574 15.9221L21.6979 17.2816L18.2991 13.8828L14.9002 17.2816L13.5407 15.9221L16.9395 12.5233L13.5407 9.12437L14.9002 7.76482L18.2991 11.1637L21.6979 7.76482L23.0574 9.12437L19.6586 12.5233Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2499_6841">
                        <rect width="23.0723" height="23.0723" fill="white" transform="translate(0.0334473 0.986816)" />
                      </clipPath>
                    </defs>
                  </svg>
                }

              </button>
              <button onClick={handleShowfairnesss}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 21" fill="none">
                  <path d="M4.88023 6.58917L4.65229 7.11208C4.48548 7.4949 3.95599 7.4949 3.78918 7.11208L3.56127 6.58917C3.155 5.65679 2.42324 4.91445 1.51014 4.50834L0.80795 4.19602C0.428275 4.02714 0.428275 3.47462 0.80795 3.30574L1.47088 3.01088C2.40746 2.59432 3.15232 1.8245 3.55162 0.860451L3.78567 0.295375C3.94879 -0.0984582 4.49269 -0.0984582 4.65581 0.295375L4.88986 0.860451C5.28915 1.8245 6.03404 2.59432 6.97065 3.01088L7.63351 3.30574C8.01328 3.47462 8.01328 4.02714 7.63351 4.19602L6.93134 4.50834C6.01826 4.91445 5.28648 5.65679 4.88023 6.58917ZM3.35517 19.9791C4.30261 14.256 6.35708 1.84562 19.9354 1.84562C18.5527 4.6188 17.6245 6.00539 16.7001 6.92978L15.7757 7.85418L17.1623 8.77857C16.2379 11.5518 13.4647 14.7871 9.76712 15.2493C7.30034 15.5576 5.75915 17.2524 5.14353 20.3335H3.29637C3.31554 20.2185 3.3351 20.1003 3.35517 19.9791Z" fill="white" />
                </svg>
              </button>
            </div>
            <div className="col-6 text-end d-flex justify-content-end align-items-center mb-my">
              <h2 className='text-white m-0'>
                <svg className='me-1' xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                  <g clipPath="url(#clip0_1973_5140)">
                    <path d="M6.90925 16.5192C3.29467 16.0673 0.455182 13.2278 0.0037703 9.61418C-0.03161 9.33498 0.186517 9.08723 0.468934 9.08723H2.36391C2.59282 9.08723 2.78785 9.2525 2.82632 9.47775C3.19075 11.636 4.8861 13.3318 7.0457 13.6967C7.27096 13.7351 7.43623 13.9302 7.43623 14.1591V16.0541C7.4362 16.3329 7.19448 16.5532 6.90925 16.5192ZM2.36406 8.02457H0.46909C0.186517 8.02457 -0.0314225 7.77665 0.00392657 7.49761C0.50022 3.52176 3.89736 0.523438 7.90521 0.523438C9.68573 0.523438 11.3738 1.10396 12.7871 2.20232C13.0119 2.37769 13.0287 2.70652 12.831 2.90417L11.4914 4.24425C11.3293 4.40677 11.0748 4.42693 10.888 4.2946C10.0085 3.66782 8.97696 3.33636 7.90518 3.33636C5.38299 3.33636 3.24673 5.14388 2.82644 7.63404C2.788 7.85926 2.59297 8.02457 2.36406 8.02457ZM8.49886 16.0545V14.1595C8.49886 13.9306 8.66414 13.7356 8.88939 13.6971C11.3795 13.2768 13.1871 11.1406 13.1871 8.61837C13.1871 7.54659 12.8556 6.51509 12.2288 5.63558C12.0961 5.44924 12.1171 5.19377 12.2792 5.03215L13.6193 3.69254C13.8144 3.49742 14.1442 3.50979 14.3211 3.73648C15.4195 5.14982 16 6.83786 16 8.61834C16 12.6262 13.0016 16.0233 9.02582 16.5196C8.95985 16.5279 8.89287 16.5221 8.82933 16.5025C8.7658 16.4829 8.70715 16.45 8.65731 16.4061C8.60746 16.3621 8.56755 16.3079 8.54023 16.2473C8.51291 16.1867 8.49881 16.121 8.49886 16.0545Z" fill="#00CB07" />
                    <path d="M6.12357 6.64938C6.12357 6.39047 5.91367 6.18056 5.65475 6.18056H4.71711C4.4582 6.18056 4.24829 6.39047 4.24829 6.64938V10.3999C4.24829 10.6589 4.4582 10.8688 4.71711 10.8688H5.65475C5.91367 10.8688 6.12357 10.6589 6.12357 10.3999V6.64938ZM8.9365 10.3999V5.71174C8.9365 5.45283 8.72659 5.24292 8.46768 5.24292H7.53003C7.27112 5.24292 7.06121 5.45283 7.06121 5.71174V10.3999C7.06121 10.6589 7.27112 10.8688 7.53003 10.8688H8.46768C8.72662 10.8688 8.9365 10.6589 8.9365 10.3999ZM11.7494 10.3999V8.52466C11.7494 8.26575 11.5395 8.05584 11.2806 8.05584H10.343C10.084 8.05584 9.87414 8.26575 9.87414 8.52466V10.3999C9.87414 10.6589 10.084 10.8688 10.343 10.8688H11.2806C11.5395 10.8688 11.7494 10.6589 11.7494 10.3999Z" fill="#00CB07" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1973_5140">
                      <rect width="16" height="16" fill="white" transform="translate(0 0.523193)" />
                    </clipPath>
                  </defs>
                </svg>
                Live Stats
              </h2>
            </div>
          </div>
          <Modal show={showfairnesss} onHide={handleClosefairnesss} className='fairnesss modal-slide-up'>
            <Modal.Body>
              <div className="row">
                <div className="col-6">
                  <h1 className='text-white m-0 d-flex align-items-center' style={{ height: '100%' }}>
                    <svg className='me-1' xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <g clipPath="url(#clip0_1842_8962)">
                        <path d="M4.13084 6.32206L3.91474 6.81782C3.75659 7.18077 3.25459 7.18077 3.09644 6.81782L2.88036 6.32206C2.49518 5.43808 1.80141 4.73428 0.935711 4.34925L0.269974 4.05314C-0.0899912 3.89303 -0.0899912 3.36919 0.269974 3.20908L0.89849 2.92952C1.78645 2.53459 2.49264 1.80474 2.87121 0.890733L3.09311 0.354992C3.24776 -0.0183957 3.76343 -0.0183957 3.91808 0.354992L4.13998 0.890733C4.51854 1.80474 5.22476 2.53459 6.11275 2.92952L6.7412 3.20908C7.10125 3.36919 7.10125 3.89303 6.7412 4.05314L6.07548 4.34925C5.20979 4.73428 4.51601 5.43808 4.13084 6.32206ZM2.68496 19.0169C3.58321 13.5909 5.53103 1.82476 18.4045 1.82476C17.0936 4.45398 16.2135 5.76858 15.3371 6.64499L14.4607 7.52139L15.7753 8.3978C14.8989 11.027 12.2697 14.0944 8.76405 14.5326C6.42532 14.8249 4.96414 16.4317 4.38048 19.3529H2.62921C2.64739 19.2438 2.66593 19.1318 2.68496 19.0169Z" fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_1842_8962">
                          <rect width="21.0337" height="21.0337" fill="white" transform="translate(0 0.483154)" />
                        </clipPath>
                      </defs>
                    </svg>
                    Fairnesss
                  </h1>
                </div>
                <div className="col-6 text-end">
                  <button onClick={handleClosefairnesss} className='bt-Close'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z" fill="#CCCCCC" />
                    </svg>
                  </button>
                </div>
              </div>
              <Fairnesss />
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  )

}

export default Mines;